var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChatbotAvailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2_00000081647460326210925520000009732913499267758213_",
  x: "0px",
  y: "0px",
  viewBox: "0 0 18 18",
  style: {
    enableBackground: "new 0 0 18 18"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t\t.st1{display:inline;fill:none;}\n\t\t.st2{display:inline;fill:#233750;}\n\t\t.st3{fill:#233750;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M13.3,6.6v6.5H6.5H6.1l-0.4,0.3l-1,0.9V6.6H13.3 M13.5,5.4h-9c-0.6,0-1.1,0.5-1.1,1.1v10.8l3.1-2.9h7 c0.6,0,1.1-0.5,1.1-1.1V6.4C14.6,5.9,14.1,5.4,13.5,5.4L13.5,5.4z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M10.4,5.7L10.4,5.7c0.1,0.1,0,0.2,0,0.2H7.6c0,0-0.1,0-0.1-0.1s0-0.1,0.1-0.1H10.4 M10.4,4.9H7.6 c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.7c0.5,0,0.8-0.4,0.8-0.8S10.8,4.9,10.4,4.9L10.4,4.9z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M14.8,8h-0.4c-0.6,0-1.1,0.5-1.1,1.1v1.7c0,0.6,0.5,1.1,1.1,1.1h0.4c0.6,0,1.1-0.5,1.1-1.1V9 C15.8,8.4,15.4,8,14.8,8L14.8,8z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M3.5,8H3.1c-0.6,0-1,0.4-1,1v1.7c0,0.6,0.5,1.1,1.1,1.1h0.4c0.6,0,1.1-0.5,1.1-1.1V9C4.6,8.4,4.1,8,3.5,8 L3.5,8z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M9,4.1c-0.6,0-1.1,0.5-1.1,1.1s0.5,1,1.1,1s1.1-0.5,1.1-1.1S9.6,4.1,9,4.1L9,4.1z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M9,1.1L9,1.1c0.4,0,0.7,0.3,0.7,0.7l0,0c0,0.4-0.3,0.7-0.7,0.7l0,0c-0.4,0-0.7-0.3-0.7-0.7l0,0 C8.3,1.4,8.6,1.1,9,1.1z"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "9.3,2.1 8.7,2.1 8.7,5.4 9.3,5.4  "
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M9,12.1c-0.5,0-1-0.1-1.5-0.4c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2c0.7,0.3,1.4,0.3,2.1,0 c0.2-0.1,0.5,0,0.7,0.2c0.1,0.2,0,0.5-0.2,0.7C10,12,9.5,12.1,9,12.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M8,10c-0.3,0-0.5-0.2-0.5-0.5V8.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.4C8.5,9.8,8.3,10,8,10z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M10,10c-0.3,0-0.5-0.2-0.5-0.5V8.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.4C10.5,9.8,10.3,10,10,10z"
}))))));
export default __webpack_public_path__ + "static/media/Chatbot_available.8d3f2bac.svg";
export { SvgChatbotAvailable as ReactComponent };